import React, { useState, useEffect } from "react";
import admin from "../../../services/adminService";
const Teams = () => {
  const [teamMember, setTeamMember] = useState([]);

  useEffect(() => {
    let teamMember = admin.getTeamMember();
    setTeamMember(teamMember);
  }, [teamMember]);

  return (
    <div className="container-fluid" id="team">
      <section className="section pt-5 team-section">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center my-3 font-weight-bold h1">
              Our amazing team
            </h2>
          </div>

          <p className="text-center font-weight-bolder mb-5 w-responsive mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
            error amet numquam iure provident voluptate esse quasi, veritatis
            totam voluptas nostrum quisquam eum porro a pariatur veniam.
          </p>

          <div className="row text-center text-md-left mx-0 justify-content-center">
            {teamMember.map((member, index) => (
              <div
                key={member.name + index}
                className="col-lg-6 px-0 px-md-2 col-md-10 col-sm-10 mb-4"
              >
                <div className="card card-body rgba-white-slight hoverable p-0 mb-4 m-0 rgba-white-slight overflow-hidden rounded mb-0 hoverable">
                  <div className="row">
                    <div className="col-md-4 float-left pr-md-0">
                      <div
                        className="avatar mx-auto d-flex justify-content-center"
                        style={{ overflow: "hidden" }}
                      >
                        <img
                          src={member.photoURL}
                          className="z-depth-1"
                          alt={member.name}
                        />
                      </div>
                    </div>
                    <div className="col-md-8 float-right pl-md-4">
                      <h4 className="mt-md-4 mt-4">
                        <strong>{member.name}</strong>
                      </h4>
                      <h6 className="font-weight-bold mb-4">{member.title}</h6>
                      <p>{member.description}</p>
                      <div className="mb-3 d-inline-block">
                        {member.social.map((social) => (
                          <a
                            key={social.label}
                            style={{ width: 35, height: 35, margin: "0.15rem" }}
                            className={`btn-floating btn-small bg-light`}
                            aria-label={social.label}
                            rel="noopener noreferrer"
                            target="_blank"
                            href={social.link}
                          >
                            <i
                              style={{ fontSize: "1rem", lineHeight: "35px" }}
                              className={social.icon + " " + social.anchorClass}
                            ></i>
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Teams;
